<template>
  <!-- preview container -->
  <div class="image-preview" v-show="toDisplay" @click="clearOverlays">
    <!-- CONTENT -->
    <!-- on error -->
    <div v-if="displayError" class="error-box">
      <!-- error icon -->
      <i class="fa fa-exclamation-triangle error-icon"></i>
      <h1 class="error-heading">404</h1>
      <p v-text="retrieveErrorContent" class="error-text"></p>
    </div>
    <div v-else>
      <!-- image preview -->
      <img v-if="filetype === 'Image'" :src="retrieveContent" class="preview" />
      <video v-else :src="retrieveContent" class="preview" autoplay muted></video>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: [
    "toDisplay",
    "retrieveContent",
    "displayError",
    "retrieveErrorContent",
    "filetype",
  ],
  methods: {
    ...mapActions(["clearOverlays"]),
  },
};
</script>

<style scoped>
.preview {
  width: 100%;
  height: auto;
}
.image-preview {
  max-width: 1280px;
  min-width: 25vw;
  z-index: 1000;
  position: fixed;
  top: 20vh;
  right: 2vw;
  border: 2px black solid;
  border-radius: 3px;
  overflow: hidden;
  background-image: url("../../public/img/gifs/google-spinner.gif");
  background-size: cover;
  background-repeat: no-repeat;
  background-origin: content-box;
}
.error-box {
  background-color: lightgrey;
  width: 100%;
  height: 100%;
}
.error-icon {
  font-size: 5rem;
  margin-left: 1rem;
  margin-top: 1rem;
}
.error-heading {
  display: inline-block;
  margin-left: 5px;
  font-size: 3rem;
}
.error-text {
  margin-left: 15px;
  margin-top: 3px;
  font-size: 1.1rem;
}
</style>
